import { useState } from "react";
import { ChevronRight } from "lucide-react";
import { api, errMsg } from "../lib/api";
import { ForgotPasswordForm, ResetPasswordForm } from "./PasswordReset";

const resetToken = () => (window.location.pathname === "/reset-password" ? new URLSearchParams(window.location.search).get("token") || "" : null);

export default function Auth({ onAuth, flash }) {
  const storedRef = localStorage.getItem("tp_ref") || "";
  const [token] = useState(resetToken);
  const [mode, setMode] = useState(token !== null ? "reset" : storedRef ? "register" : "login");
  const [form, setForm] = useState({ referral_code: storedRef });
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });
  const isLogin = mode === "login";

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      const body = isLogin ? { identifier: form.identifier, password: form.password } : { name: form.name, alias: form.alias, phone: form.phone, email: form.email, password: form.password, referral_code: form.referral_code || null };
      const r = await api.post(`/auth/${mode}`, body);
      localStorage.setItem("tp_token", r.data.token);
      localStorage.removeItem("tp_ref");
      onAuth(r.data.user);
    } catch (err) {
      setError(errMsg(err, "Periksa kembali data Anda"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-art">
        <div className="brand"><span className="brand-mark">P</span><span>POJOK CHART</span></div>
        <div className="art-content">
          <p className="eyebrow">THE TRADER'S OPERATING SYSTEM</p>
          <h1>Trade with clarity.<br /><em>Grow with control.</em></h1>
          <p>Hubungkan akun trading Anda, baca performa secara jernih, dan kelola profit sharing dari satu terminal.</p>
          <div className="ticker"><span>MARKET OPEN</span><b>●</b><span>MT5 · MT4 · cTrader</span></div>
        </div>
      </div>
      <div className="auth-form-wrap">
        <div className="mobile-brand brand"><span className="brand-mark">P</span><span>POJOK CHART</span></div>
        {mode === "forgot" && <ForgotPasswordForm onBack={() => setMode("login")} />}
        {mode === "reset" && <ResetPasswordForm token={token} onDone={() => { window.history.replaceState({}, "", "/"); setMode("login"); }} />}
        {(mode === "login" || mode === "register") && <div className="auth-form">
          <p className="eyebrow">{isLogin ? "WELCOME BACK" : "START YOUR JOURNEY"}</p>
          <h2>{isLogin ? "Masuk ke terminal" : "Buat akun member"}</h2>
          <p className="muted">{isLogin ? "Kelola performa trading Anda dengan tenang." : "Buka akses ke analitik dan EA pilihan Anda."}</p>
          {flash && <div className="notice info" data-testid="auth-flash-message">{flash}</div>}
          <form onSubmit={submit} data-testid="auth-form">
            {!isLogin && (
              <>
                <label>Nama lengkap<input data-testid="register-name-input" required onChange={set("name")} /></label>
                <label>Nama samaran<input data-testid="register-alias-input" required minLength={2} maxLength={30} placeholder="Ditampilkan di leaderboard" onChange={set("alias")} /></label>
                <label>Nomor telepon<input data-testid="register-phone-input" required placeholder="08xxxxxxxxxx" onChange={set("phone")} /></label>
              </>
            )}
            <label>{isLogin ? "Email atau nomor telepon" : "Email"}
              <input data-testid="auth-identifier-input" type={isLogin ? "text" : "email"} required onChange={set(isLogin ? "identifier" : "email")} />
            </label>
            <label>Password<input data-testid="auth-password-input" type="password" required onChange={set("password")} /></label>
            {!isLogin && <label>Kode referral (opsional)<input data-testid="register-referral-input" value={form.referral_code} onChange={set("referral_code")} /></label>}
            {error && <div className="error" data-testid="auth-error">{error}</div>}
            <button className="primary full" disabled={busy} data-testid="auth-submit-button">{isLogin ? "Masuk" : "Daftar sekarang"}<ChevronRight size={17} /></button>
          </form>
          <button className="text-button" data-testid="auth-mode-toggle" onClick={() => setMode(isLogin ? "register" : "login")}>
            {isLogin ? "Belum punya akun? Daftar" : "Sudah punya akun? Masuk"}
          </button>
          {isLogin && <button className="text-button forgot-link" data-testid="forgot-password-link" onClick={() => setMode("forgot")}>Lupa password?</button>}
        </div>}
      </div>
    </div>
  );
}
